module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_10.9442c219.png";